module.exports = __webpack_public_path__ + "img/dragon.100731f5.svg";